import React from 'react';

interface SuccessIconProps {
  color?: string;
  size?: string;
}

export const SuccessIcon = ({size = '25', color = '#2FCFA4'}: SuccessIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 12.5C0 5.59644 5.59644 0 12.5 0C19.3952 0.0200237 24.98 5.60475 25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5ZM4.77708 12.5L10.4167 18.1396L20.2229 8.33333L18.75 6.86042L10.4167 15.1938L6.25 11.0271L4.77708 12.5Z" fill={color}/>
    </svg>
  );
};

export default SuccessIcon;
